import * as localizations from '../localizations/site';
const blogUrl = 'http://blog.tunein.com';

import {
  HOME_BROWSE_PATH,
  SPORTS_BROWSE_PATH,
  MUSIC_BROWSE_PATH,
  NEWS_BROWSE_PATH,
  PODCASTS_BROWSE_PATH,
  PREMIUM_BROWSE_PATH,
  OPT_OUT_PATH,
} from '../paths';

import { httpsBaseUrl, TOS, PRIVACY, CCPA, HELP_URL } from '../cmsLinks';

export default {
  aboutUs: {
    id: 'footerAboutUs',
    name: localizations.ABOUT_US,
    url: `${httpsBaseUrl}about/`,
  },
  careers: {
    id: 'footerCareers',
    name: localizations.CAREERS,
    url: `${httpsBaseUrl}careers/`,
  },
  press: {
    id: 'footerPress',
    name: localizations.PRESS,
    url: `${httpsBaseUrl}press/`,
  },
  blog: {
    id: 'footerBlog',
    name: localizations.BLOG,
    url: blogUrl,
  },
  getTuneIn: {
    id: 'footerGetTuneIn',
    name: localizations.DEVICES,
    url: `${httpsBaseUrl}get-tunein/`,
  },
  support: {
    id: 'footerSupport',
    name: localizations.SUPPORT,
    url: HELP_URL,
  },
  privacy: {
    id: 'footerPrivacy',
    name: localizations.PRIVACY,
    url: PRIVACY,
  },
  sitemap: {
    id: 'footerSitemap',
    name: localizations.SITEMAP,
    url: `${httpsBaseUrl}sitemap/`,
  },
  ccpaOptOut: {
    id: 'footerCcpaOptOut',
    name: localizations.DONT_SELL_MY_DATA,
    url: OPT_OUT_PATH,
  },
  globalOptOut: {
    id: 'footerGlobalOptOut',
    name: localizations.AD_DATA_OPT_OUT,
    url: OPT_OUT_PATH,
  },
  oneTrustSettings: {
    id: 'footerGdprOptOut',
    name: localizations.ONETRUST_PRIVACY_SETTINGS,
    hiddenLinkProps: {
      id: 'ot-sdk-btn',
      className: 'ot-sdk-show-settings',
      style: { display: 'none' },
    },
  },
  dontSellMyData: {
    id: 'footerDontSellMyData',
    name: localizations.DONT_SELL_MY_DATA,
    url: CCPA,
  },
  broadcasters: {
    id: 'footerBroadcasters',
    name: localizations.BROADCASTERS,
    url: `${httpsBaseUrl}broadcasters/`,
  },
  podcasters: {
    id: 'footerPodcasters',
    name: localizations.PODCASTERS,
    url: `${httpsBaseUrl}podcasters/`,
  },
  policies: {
    id: 'footerPolicies',
    name: localizations.TERMS,
    url: TOS,
  },
  contactUs: {
    id: 'footerContactUs',
    name: localizations.CONTACT_US,
    url: `${httpsBaseUrl}contact/`,
  },
  brand: {
    id: 'footerBrand',
    name: localizations.BRAND,
    url: `${httpsBaseUrl}business/`,
  },
  product: {
    id: 'footerProduct',
    name: localizations.PRODUCT,
    url: HOME_BROWSE_PATH,
  },
  music: {
    id: 'footerMusic',
    name: localizations.MUSIC,
    url: MUSIC_BROWSE_PATH,
  },
  sports: {
    id: 'footerSports',
    name: localizations.SPORTS,
    url: SPORTS_BROWSE_PATH,
  },
  podcasts: {
    id: 'footerPodcasts',
    name: localizations.PODCASTS,
    url: PODCASTS_BROWSE_PATH,
  },
  news: {
    id: 'footerNews',
    name: localizations.NEWS_AND_TALK,
    url: NEWS_BROWSE_PATH,
  },
  listenNow: {
    id: 'footerListenNow',
    name: localizations.LISTEN_NOW,
    url: HOME_BROWSE_PATH,
  },
  more: {
    id: 'footerMore',
    name: localizations.MORE,
    url: PREMIUM_BROWSE_PATH,
  },
};
